import styled from 'styled-components';

const Container = styled.div`
  margin-top: 0;
  display: flex;
  justify-content: space-between;
  padding: 15px 20px;
  max-width: var(--max-width);
  width: 100%;
  margin: auto;

  p {
    max-width: max-content;
    margin: 0;
    color: ${(props) => (props.isBlack ? 'var(--darkest)' : 'var(--white)')} !important;

    .announcement-bar--link {
      width: 100%;
      color: ${(props) => (props.isBlack ? 'var(--darkest)' : 'var(--white)')} !important;
      transition: none;
      &:hover {
        text-decoration: ${(props) =>
          `underline solid ${props.isBlack ? 'var(--darkest)' : 'var(--white)'} 2px;`};
      }
    }
  }

  .announcement-bar-right {
    display: flex;
    align-items: center;

    a {
      color: ${(props) => (props.isBlack ? 'var(--darkest)' : 'var(--white)')} !important;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: none;
      &:hover {
        text-decoration: ${(props) =>
          `underline solid ${props.isBlack ? 'var(--darkest)' : 'var(--white)'} 2px;`};
      }
    }

    .announcement-bar--icon {
      height: 14px;
      width: 14px;
      margin-left: 10px;
    }

    .phone-icon {
      height: 20px;
      width: 20px;
      margin-left: 0;
    }
  }

  @media (max-width: 1450px) {
    p {
      font-size: var(--font-size-13);
    }
  }
`;

export { Container };
